export const enum EMortgageOffersTabs {
  Banks = 'banks',
  Mortgage = 'mortgage',
  SeoUrl = 'seo_url',
}
